module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"L","commonjs":"leaflet","commonjs2":"leaflet","amd":"leaflet"}
// module id = 1
// module chunks = 0